import { inlineSelectStyles } from '@upright/ui/common/generic/utilities/selectStyles';
import { isNil, toString } from 'lodash';
import Select, { GroupBase, Props } from 'react-select';

type DropdownInputProps<T> = Partial<
  Props<{ label: string; value: T }, false, GroupBase<{ label: string; value: T }>>
> & {
  selectOptions: T[];
  selected: T | undefined;
  setSelected: (value: T | undefined) => void;
  toFriendlyLabel?: (value: T) => string;
};
/**
 * Convenience wrapper for react-select. This accepts all <Select /> props and passes them on to <Select />. Feel free to modify and expand
 * NOTE: Since upgrading react-select to v5, there is no much reason to use this anymore. -ML
 */
export function DropdownInput<T>(props: DropdownInputProps<T>) {
  const toOption = (v: T) => toSelectOption(v, props.toFriendlyLabel);
  return (
    <Select<{ label: string; value: T }, false>
      {...props}
      isMulti={false}
      value={!isNil(props.selected) ? toOption(props.selected) : undefined}
      options={props.selectOptions.map(toOption)}
      onChange={newSelection => {
        props.setSelected(newSelection ? newSelection.value : undefined);
      }}
      styles={{ ...inlineSelectStyles, ...props.styles }}
    />
  );
}

function toSelectOption<T>(value: T, toFriendlyLabel: (value: T) => string = toString) {
  return {
    value,
    label: toFriendlyLabel(value),
  };
}
